import { notification } from '@surecompanies/core_components'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setAssignmentQueues } from '../slices/applicationQueueSlice'
import { useBenefitQueuesQuery } from './useBenefitQueuesQuery'

export function useBenefitQueues() {
  const dispatch = useDispatch()
  const { data, error } = useBenefitQueuesQuery()

  useEffect(() => {
    if (data) {
      dispatch(setAssignmentQueues(data))
    }
  }, [data, dispatch])

  useEffect(() => {
    if (error) {
      notification.error({
        message: error.message,
      })
    }
  }, [error])

  return {
    assignmentQueues: data || [],
    error,
  }
}
